import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Placeholder from './Placeholder.jsx';
import styles from './ObservationItem.module.css';

function ObservationItem({label, icon, primaryValue, secondaryValue = false, unit = false}) {
  return (
    <div className={styles.ObservationItem} >
      <div className={styles.ObservationIconBox}>
        <FontAwesomeIcon icon={icon} className={styles.ObservationIcon} size="2xl" />
      </div>
      <div className={styles.ObservationTextArea}>
        <h6 className={styles.ObservationTitle}>{label}</h6>
        <div className={styles.PrimaryValue}>
          <Placeholder ready={primaryValue} xs={6}>
            <span className={styles.PrimaryStat}>
              {Number.isFinite(primaryValue) ? primaryValue.toFixed(1) : primaryValue}
            </span>
            {unit !== false && <span className={styles.PrimaryUnit}>&nbsp;{unit}</span>}
          </Placeholder>
        </div>
        {secondaryValue !== false && (
          <div className={styles.SecondaryValue}>
            <Placeholder ready={secondaryValue} xs={10}>
              {secondaryValue}
            </Placeholder>
          </div>
        )}
      </div>
    </div>
  )
}

export default ObservationItem;
